import React from 'react';

import CategoryCarousel from '@mshops-components-library/categories-carousel';

import withMetadata from '../../adapters/withMetadata';

/* TODO: this wrapper is added in order to hide carousel pagination using css, remove once andes component fixed */
const Wrapper = (props) => (
  <section className="category-carousel__container">
    <CategoryCarousel {...props} />
  </section>
);

export default withMetadata(Wrapper);
